<template>
  <div class="toggle-block">
    <button
      class="bordered item"
      v-for="(val, name) in items"
      :key="name"
      :class="{ active: active === val }"
      @click="select(val)"
      :disabled="disabled && disabled[val]"
    >
      <slot :val="{ val, name }">{{ name }}</slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  model: {
    event: 'change',
    prop: 'active',
  },
  props: {
    active: {},
    disabled: {},
    items: {
      default: () => ({
        Day: true,
        All: false,
      }),
    },
  },
  methods: {
    select(val) {
      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss">
.toggle-block {
  display: flex;

  .item {
    &:not(:last-child) {
      border-right: none;
    }

    &:first-child {
      border-radius: 5px 0 0 5px;
    }

    &:last-child {
      border-radius: 0 5px 5px 0;
    }

    &.active {
      background: $primary;
      color: $white;
      border-color: $primary;
    }
  }
}
</style>
